const mobile = '@MOBILE/'
export const TOGGLE_MOBILE = `${mobile}TOGGLE_MOBILE`
export const TOGGLE_NAV = `${mobile}TOGGLE_NAV`
export const OPEN_SCREEN = `${mobile}OPEN_SCREEN`
export const TRY_OPEN_SCREEN = `${mobile}TRY_OPEN_SCREEN`
